import * as React from 'react';
import TextField from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';
import { ECompanyOrAssociationStatus } from '../../../../models/user/UserInfosModel';
import { Box, IconButton, MenuItem } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { GREEN_MAIN, GREEN_LOGO } from '../../../../theme/colors';

interface AdminApprovalProps {
    approvedFromAssociation: ECompanyOrAssociationStatus; // Valore iniziale passato come prop
    approvedFromAssociationReset: ECompanyOrAssociationStatus;
    handleChange: (value: string, key: string) => void; // Funzione per aggiornare lo stato
}

const AdminApproval: React.FC<AdminApprovalProps> = ({ approvedFromAssociation, approvedFromAssociationReset, handleChange }) => { 
    const { t } = useTranslation();
    const [selectedValue, setSelectedValue] = React.useState<number>(approvedFromAssociation);
    const handleSelectChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
        setSelectedValue(Number(value));
        handleChange(value, 'companyOrAssociationStatus'); // Inviamo il cambiamento al padre
    };
    
      // Funzione per resettare il valore al valore iniziale
    const handleReset = () => {
        setSelectedValue(approvedFromAssociationReset);
        handleChange(approvedFromAssociationReset.toString(), 'companyOrAssociationStatus'); // Ripristiniamo il valore originale
    };

    return (
        <Box 
            sx={{display:'flex'}}
        >
            <TextField
                select
                value={selectedValue.toString()}
                onChange={handleSelectChange}
                sx={{
                    width: '100%',
                    marginBottom: 0,
                    marginTop: 0,
                    height: '45px',
                    '& .MuiOutlinedInput-notchedOutline': {
                        color: GREEN_MAIN,
                    },
                    '& .MuiSelect-select': {
                        padding: '12px 12px',
                        lineHeight: 1.4,
                        color: "grey",
                        fontSize: '1rem',
                        textTransform: 'none'
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: GREEN_LOGO,
                        color: GREEN_MAIN,
                    },
                    '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'grey !important',
                    }
                }}
                InputProps={{
                    style: {
                        marginTop: 0,
                        marginBottom: 0,
                    },
                }}
            >
                {Object.keys(ECompanyOrAssociationStatus).map((key) => {
                    const typedKey = key as keyof typeof ECompanyOrAssociationStatus;
                    if (isNaN(Number(typedKey))) {
                        const value = ECompanyOrAssociationStatus[typedKey];
                        const displayValue = value === 0 ? 0 : value;
            
                        return (
                        <MenuItem key={typedKey} value={displayValue}>
                            {t(typedKey)}
                        </MenuItem>
                        );
                    }
                    return null;
                })}
            </TextField>
    
            {/* Bottone per resettare il valore */}
            <Box sx={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                <IconButton onClick={handleReset} sx={{ 
                    width:'45px', 
                    height:'45px',
                    color: GREEN_MAIN
                }}>
                    <ClearIcon />
                </IconButton>
            </Box>
        </Box>
      );
  }

  export default AdminApproval;